import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberInputMaskPipe',
})
export class NumberInputMaskPipe implements PipeTransform {
  amount: any;

  // TODO should work with diffrent languages
  transform(value: any, options?: { suffix?: string; decimals?: number }): any {
    let amount = String(value);

    const beforePoint = options
      ? options.decimals
        ? amount.split(/[\,\.]/)[0]
        : amount
      : amount;
    let integers = '';
    if (typeof beforePoint !== 'undefined' && beforePoint != '') {
      integers = beforePoint.replace(/\D+/g, '');
      integers = Number(integers).toLocaleString('pl');
    }
    const afterPoint =
      amount.search(/[\,\.]/) > -1
        ? amount.substring(amount.search(/[\,\.]/))
        : undefined;
    if (integers === '' && afterPoint != null && afterPoint !== '') {
      integers = '0';
    }
    let decimals = '';
    if (options && options.decimals) {
      if (typeof afterPoint !== 'undefined') {
        decimals = afterPoint ? afterPoint.replace(/\D+/g, '') : null;
      }
      if (decimals.length > options.decimals) {
        decimals = decimals.slice(0, options.decimals);
      }
    }
    amount = integers;
    if (
      amount != '' &&
      typeof afterPoint === 'string' &&
      options &&
      options.decimals
    ) {
      amount += ',';
    }
    if (decimals.length > 0) {
      amount += decimals;
    }
    if (amount != '' && options && options.suffix) {
      amount += options.suffix;
    }
    return amount;
  }
}
